import { ScheduleEntry, ScheduleEntryType, Project } from "domain-entities";
import { color } from "Configs/theme";
import { DropArea } from "Components/DropArea/types/DropArea";

export function getColorRgbaFromHex(hex: string, alpha?: number) {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);

	if (alpha === undefined) {
		return `rgba(${r}, ${g}, ${b})`;
	} else {
		return `rgba(${r}, ${g}, ${b}, ${alpha})`;
	}
}

export const COLOR_TAGS = {
	COLOR10: "#211BDE",
	COLOR6: "#0091FF",
	COLOR5: "#B620E0 ",
	COLOR8: "#CF006C",
	COLOR1: "#DC0E0E",
	COLOR2: "#AA6900",
	COLOR3: "#F7B500",
	COLOR9: "#818D74",
	COLOR4: "#5BB000",
	COLOR7: "#44D7B6",
};

export const SORTED_COLOR_TAGS: (keyof typeof COLOR_TAGS)[] = [
	"COLOR10",
	"COLOR6",
	"COLOR5",
	"COLOR8",
	"COLOR1",
	"COLOR2",
	"COLOR3",
	"COLOR9",
	"COLOR4",
	"COLOR7",
];

export const FALLBACK_COLOR_HEX = color.text;
export const FALLBACK_DROP_AREA_COLOR_HEX = color.lightText;
export const DEFAULT_COLOR_TAG = "COLOR1";
export const MERGED_CALENDAR_ENTRY_COLOR_HEX = color.text;

export function getColorHex(colorTag?: string, fallbackColorHex?: string) {
	if (colorTag !== undefined && colorTag in COLOR_TAGS) {
		return COLOR_TAGS[colorTag as keyof typeof COLOR_TAGS];
	} else {
		return fallbackColorHex || FALLBACK_COLOR_HEX;
	}
}

export function getTextColorFromBackgroundColor(
	backgroundColorHex: string,
	isFilled?: boolean
) {
	if (isFilled) {
		return color.totalBackground;
	} else {
		return backgroundColorHex;
	}
}

export function getColorHexFromScheduleEntry(
	scheduleEntry: ScheduleEntry,
	projects: Project[],
	scheduleEntryTypes: ScheduleEntryType[]
) {
	if (scheduleEntry.projectId) {
		const project = projects.find(
			(project) => project.id === scheduleEntry.projectId
		);

		if (project) {
			return getColorHex(project.colorTag);
		}
	} else {
		const scheduleEntryType = scheduleEntryTypes.find(
			(type) => type.id === scheduleEntry.typeId
		);

		if (scheduleEntryType) {
			return getColorHex(scheduleEntryType.colorTag);
		}
	}

	return FALLBACK_COLOR_HEX;
}

export function getColorHexFromDropArea(
	dropArea: DropArea,
	scheduleEntryTypes: ScheduleEntryType[]
) {
	const scheduleEntryType = scheduleEntryTypes.find(
		(type) => type.id === dropArea.typeId
	);

	if (scheduleEntryType) {
		return getColorHex(
			scheduleEntryType.colorTag,
			FALLBACK_DROP_AREA_COLOR_HEX
		);
	} else {
		return FALLBACK_DROP_AREA_COLOR_HEX;
	}
}
